// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../employee/node_modules/css-loader/index.js??ref--1-oneOf-2-1!../../../../../../employee/node_modules/postcss-loader/lib/index.js??postcss!./index.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = require("!../../../../../../employee/node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../employee/node_modules/css-loader/index.js??ref--1-oneOf-2-1!../../../../../../employee/node_modules/postcss-loader/lib/index.js??postcss!./index.css", function() {
			var newContent = require("!!../../../../../../employee/node_modules/css-loader/index.js??ref--1-oneOf-2-1!../../../../../../employee/node_modules/postcss-loader/lib/index.js??postcss!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/User/components/LanguageSelectionForm/index.css
// module id = ../lib/egov-ui-kit/common/User/components/LanguageSelectionForm/index.css
// module chunks = 504